export default function fillNewsletterInput() {
  const initialInput = document.querySelector(
    "[data-newsletter-initial-input]"
  );
  const newsletterInput = document.querySelector(".newsletter-input input");

  if (initialInput && newsletterInput) {
    initialInput.addEventListener("change", () => {
      newsletterInput.value = initialInput.value;
    });
  }
}
